import React from "react";
import { useNavigate } from "react-router-dom";

import { chatHelpMessage } from "@/lib/helper";
import { HomeIcon } from "lucide-react";
import WhatsappIcon from "@/assets/icons/whatsapp-icon-green.svg";

const HomeFaqWhatsappHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-8 px-6">
      <div className="flex flex-row justify-between items-center">
        <div className="flex gap-6 items-center">
          <button onClick={() => navigate("/")}>
            <HomeIcon className="size-5" />
          </button>
          <button
            onClick={() => navigate("/faq")}
            className="text-xs font-normal"
          >
            FAQ's
          </button>
        </div>

        <button
          onClick={() => chatHelpMessage()}
          className="gap-1 flex justify-between items-center"
        >
          <img src={WhatsappIcon} alt="" className="scale-150" />
        </button>
      </div>
    </div>
  );
};

export default HomeFaqWhatsappHeader;
